import { type z } from 'zod';

import { makeCursorQuery } from '../../common/cursor-page/cursor-page';

/**
 * Reading a conversation's history, newest first.
 *
 * Cursor-paginated (`before` + `limit`), never offset — a live timeline is the
 * case offsets get wrong, and `common/cursor-page` argues it in full.
 *
 * **No filters at all**, deliberately. Everything a member might want to narrow
 * by — the sender, a date, a search term — either is not a feature yet or would
 * need its own index and its own thinking about what a moderated message does in
 * a search result. A whitelist of nothing is the honest starting point, and N7
 * makes the schema refuse anything else rather than ignore it.
 *
 * There is no `after`. The direction a chat is read is backwards; the *forward*
 * direction is what P18b's socket delivers, and a member who was offline
 * backfills by re-reading the newest page rather than by walking forwards from
 * a stale cursor.
 */
export const MessageHistoryQuerySchema = makeCursorQuery();

export type MessageHistoryQuery = z.infer<typeof MessageHistoryQuerySchema>;
